import { TARGET_AUDIENCE_ALL } from "../app/OfficeHours/ManageOfficeHours/types";

export default {
    id: null,
    isActive: true,
    name: "",
    officeHoursTitle: "",
    settings: {
        maxAppointmentsPerSession: 1,
        maxNumberOfAttendees: 1,
        earliestBooking: 0,
        latestBooking: 0,
        targetAudience: TARGET_AUDIENCE_ALL,
        allowFileUpload: true,
        requireBookingNote: false,
        receiveSummaryEmailAheadUpcomingAppointments: false,
    },
    admins: [],
    users: [],
    teamSummaryAtEight: true,
};
